// When the AI gives up. It counts the turns in a row on which its search
// was far behind at its move. Pure. `aiDriver.ts` holds the count and makes
// the action.

import { AI_CONCEDE_LEAD, AI_CONCEDE_TURNS } from '../constants';

export type BehindCount = {
  /** The match the count belongs to. */
  seed: number;
  /** The last ply counted. */
  ply: number;
  /** The turns in a row far behind, before that ply. */
  before: number;
  /** The turns in a row far behind, with that ply. */
  turns: number;
};

export const NO_BEHIND_COUNT: BehindCount = { seed: 0, ply: -1, before: 0, turns: 0 };

/**
 * The count after the side looked for its move at this ply and got this
 * score. A second look in the same ply takes the place of the first: a piece
 * that moves again, or a decision that started again. Another match, or an
 * earlier ply, starts from zero.
 */
export const countBehind = (
  count: BehindCount,
  seed: number,
  ply: number,
  score: number,
): BehindCount => {
  const sameMatch = seed === count.seed && ply >= count.ply;
  const before = !sameMatch ? 0 : ply === count.ply ? count.before : count.turns;
  return { seed, ply, before, turns: score <= -AI_CONCEDE_LEAD ? before + 1 : 0 };
};

export const givesUp = (count: BehindCount): boolean => count.turns >= AI_CONCEDE_TURNS;
